import { customizeError } from '@chilecompra/react-kit'
import { makeActionCreator } from '../../config/store/utils'
import { CLAIMS_OPTIONS_DICTIONARY, MONTHS } from '../../config/settings/constant'
import theme from '../../config/styles/theme'
import { getClaimsChart } from '../../services/claims'

export const GET_CLAIM_INFORMATION = 'GET_CLAIM_INFORMATION'
export const GET_CLAIM_INFORMATION_ERROR = 'GET_CLAIM_INFORMATION_ERROR'
export const GET_CLAIM_INFORMATION_SUCCESS = 'GET_CLAIM_INFORMATION_SUCCESS'
export const onGetClaimInformation = makeActionCreator(GET_CLAIM_INFORMATION)
export const onGetClaimInformationError = makeActionCreator(GET_CLAIM_INFORMATION_ERROR, 'payload')
export const onGetClaimInformationSuccess = makeActionCreator(GET_CLAIM_INFORMATION_SUCCESS, 'payload')
export const onGetClaimInformationChartThunk = payload => async dispatch => {
  dispatch(onGetClaimInformation())

  try {
    const {
      data: { payload: data }
    } = await getClaimsChart({ actionType: GET_CLAIM_INFORMATION, dni: payload })

    const totalClaim = data?.totalReclamos
    const hasData = data?.data?.length > 0
    const rangeDate = {
      initialMonth: MONTHS[data.periodo?.mesInicial - 1],
      initialYear: data.periodo?.añoInicial,
      finalMonth: MONTHS[data.periodo?.mesFinal - 1],
      finalYear: data.periodo?.añoFinal
    }

    const chartData = []
    const claimType1 = data?.data.filter(item => item.tipoReclamoId === CLAIMS_OPTIONS_DICTIONARY.irregularity)
    const claimType2 = data?.data.filter(item => item.tipoReclamoId === CLAIMS_OPTIONS_DICTIONARY.paymentNotTime)

    if (claimType1.length > 0) {
      chartData.push({
        name: 'Irregularidad en el proceso de compra',
        id: claimType1[0]?.tipoReclamoId,
        orders: claimType1[0]?.cantidadReclamos,
        amount: claimType1[0]?.cantidadReclamos,
        percentage: claimType1[0]?.porcentajeReclamo,
        dateUpdate: claimType1[0]?.fechaActualizacion?.replace('T', ' '),
        color: theme.palette.charts.cyan
      })
    }

    if (claimType2.length > 0) {
      chartData.push({
        name: 'Pago no oportuno',
        id: claimType2[0]?.tipoReclamoId,
        orders: claimType2[0]?.cantidadReclamos,
        amount: claimType2[0]?.cantidadReclamos,
        percentage: claimType2[0]?.porcentajeReclamo,
        dateUpdate: claimType2[0]?.fechaActualizacion?.replace('T', ' '),
        color: theme.palette.charts.ruby
      })
    }

    const claimsIrregularity = claimType1[0]?.cantidadReclamos ?? 0
    const paymentNotTime = claimType2[0]?.cantidadReclamos ?? 0

    return dispatch(
      onGetClaimInformationSuccess({
        chartData,
        totalClaim,
        claimsIrregularity,
        paymentNotTime,
        rangeDate,
        hasData
      })
    )
  } catch (error) {
    if (error?.originalError?.code === 'ERR_CANCELED') {
      return
    }
    let reason
    switch (error.code) {
      case 401:
        reason = 'UNAUTHORIZED_ERROR'
        break
      case 403:
        reason = 'FORBIDDEN_ERROR'
        break
      case 404:
        reason = 'NOT FOUND'
        break
      default:
        reason = 'SOMETHING_WENT_WRONG_ERROR'
        break
    }
    return dispatch(
      onGetClaimInformationError({
        error: customizeError({ originalError: error?.originalError, code: error.code, reason }).toObject()
      })
    )
  }
}
